export default __webpack_public_path__ + "static/media/pong.3d82eb9b.png";